import React from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { CouponProvider } from "./context/CouponContext";
import { WishlistProvider } from "./context/WishlistContext";

import CartDrawer from "./components/CartDrawer";
import ExitIntentPopup from "./components/ExitIntentPopup";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import RecentPurchaseToast from "./components/RecentPurchaseToast";
import WhatsAppButton from "./components/WhatsAppButton";

import AdminDashboard from "./pages/AdminDashboard";
import AdminForgotPassword from "./pages/AdminForgotPassword";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import { AddBlog, BlogList as AdminBlogList, EditBlog } from "./pages/Admin/Blog";
import ProductImport from "./pages/Admin/ProductImport";
import { BlogDetails, BlogList } from "./pages/Blog";
import CartPage from "./pages/Cart";
import Checkout from "./pages/Checkout/index.jsx";
import ContactUs from "./pages/ContactUs";
import CustomDesign from "./pages/CustomDesign";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import OrderSuccess from "./pages/OrderSuccess";
import PaymentReturn from "./pages/PaymentReturn";
import PaymentBridge from "./pages/PaymentBridge";
import ProductDetail from "./pages/ProductDetail";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import ShippingReturns from "./pages/ShippingReturns";
import Shop from "./pages/Shop";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import SizeGuide from "./pages/SizeGuide";
import TrackOrder from "./pages/TrackOrder";
import VerifyOtp from "./pages/VerifyOtp";
import WhyChooseCynos from "./pages/WhyChooseCynos";
import Wishlist from "./pages/Wishlist";

const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const StorefrontLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
    <CartDrawer />
    <WhatsAppButton />
    <ExitIntentPopup />
    <RecentPurchaseToast />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CustomerAuthProvider>
          <AuthProvider>
            <CartProvider>
              <CouponProvider>
                <WishlistProvider>
                  <ScrollTop />
                  <Routes>
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/blogs" element={<AdminBlogList />} />
                    <Route path="/admin/blog/add" element={<AddBlog />} />
                    <Route path="/admin/blog/edit/:id" element={<EditBlog />} />
                    <Route path="/admin/products/import" element={<ProductImport />} />

                    {/* Standalone SocioManch Payment Bridge - no Cynos layout */}
                    <Route path="/pay" element={<PaymentBridge />} />
                    <Route path="/payment/phonepe/return" element={<PaymentReturn />} />
                    <Route path="/payment/phonepe/redirect" element={<PaymentReturn />} />

                    <Route
                      path="/*"
                      element={
                        <StorefrontLayout>
                          <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/product/:slug" element={<ProductDetail />} />
                            <Route path="/blog" element={<BlogList />} />
                            <Route path="/blog/:slug" element={<BlogDetails />} />
                            <Route path="/cart" element={<CartPage />} />
                            <Route path="/wishlist" element={<Wishlist />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/:id" element={<OrderSuccess />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/signin" element={<SignIn />} />
                            <Route path="/signup" element={<SignUp />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/verify-otp" element={<VerifyOtp />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/auth/google/callback" element={<AuthCallback />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />

                            <Route path="/shipping-returns" element={<ShippingReturns />} />
                            <Route path="/size-guide" element={<SizeGuide />} />
                            <Route path="/track-order" element={<TrackOrder />} />
                            <Route path="/contact" element={<ContactUs />} />
                            <Route path="/custom-design" element={<CustomDesign />} />
                            <Route path="/why-choose-cynos" element={<WhyChooseCynos />} />
                            <Route path="*" element={<Home />} />
                          </Routes>
                        </StorefrontLayout>
                      }
                    />
                  </Routes>
                  <Toaster position="top-center" theme="dark" />
                </WishlistProvider>
              </CouponProvider>
            </CartProvider>
          </AuthProvider>
        </CustomerAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
